import { BaseApi } from '@smorder/logic';

class LocationApi extends BaseApi {
  loadAreas(locationId) {
    return this.authorizedFetch(`/api/v1/customer/locations/${locationId}/areas`);
  }
}

export default LocationApi;
